module.exports = __webpack_public_path__ + "img/top_background_bar.050e84aa.png";